module.exports = {
	languages: {
		// Default language to be redirected to when no locale is specified .e.g / > /fr
		default: "fr",
		// Enables languages. Drupal must have these enabled.
		enabled: ["fr", "ar", "Tfng", "en", "it", "es", "nl", "de"],
		// enabled: ["fr"],
		// Languages labels, mostly used by dropdowns.
		labels: [
			{ code: "en", label: "English" },
			{ code: "fr", label: "Français" },
			{ code: "ar", label: "العربية" },
			// { code: "Tfng", label: "ⵜⴰⵎⴰⵣⵉⵖⵜ" },
		],
	},
	externalLangs: ["it", "es", "nl", "de"],
	// List of menus used by frontend (useMenu hook). Must exists in Drupal.
	menus: ["main", "menu-top", "footer", "footer-bottom", "topmenu", "bottom"],
	images: {
		remotePatterns: [
			{ protocol: "http", hostname: "localhost", pathname: "/**" },
			{ protocol: "https", hostname: "vactory8.lndo.site", pathname: "/**" },
			{ protocol: "https", hostname: "backend-mdm.leserveurdetest.com", pathname: "/**" },
			{ protocol: "https", hostname: "backend.attijarimdm.com", pathname: "/**" },
			{ protocol: "https", hostname: "mdmpreprod.onecloud.ma", pathname: "/**" },
			...(process.env.NEXT_IMAGE_DOMAIN
				? [
						{
							protocol: "https",
							hostname: process.env.NEXT_IMAGE_DOMAIN,
							pathname: "/**",
						},
					]
				: []),
		],
		dangerouslyAllowLocalIP: true,
		dangerouslyAllowSVG: true,
		// contentSecurityPolicy: "default-src 'self'; script-src 'none'; sandbox;",
		deviceSizes: [640, 750, 328, 828, 1080, 1200, 1920],
		imageSizes: [16, 32, 48, 64, 96, 128, 256, 384],
		formats: ["image/webp"],
		minimumCacheTTL: 60,
		qualities: [75, 80, 100],
	},
	performance: {
		widgets: {
			mode: "all", // all or selective
			list: [],
		},
	},
	// Security tweaks.
	// HSTS is intentionally omitted here: Cloudflare already sends it.
	// Setting it again causes "Multiple Header Entries" scanner findings.
	security: {
		headers: [
			{
				key: "X-DNS-Prefetch-Control",
				value: "on",
			},
			{
				key: "X-Frame-Options",
				value: "SAMEORIGIN",
			},
			{
				key: "Permissions-Policy",
				value: "camera=(), microphone=(), geolocation=(self)",
			},
			{
				key: "X-Content-Type-Options",
				value: "nosniff",
			},
			{
				key: "Referrer-Policy",
				value: "strict-origin-when-cross-origin",
			},
			{
				key: "Cross-Origin-Opener-Policy",
				value: "same-origin-allow-popups",
			},
			{
				key: "Cross-Origin-Resource-Policy",
				value: "same-site",
			},
			// Report-Only first: switch key to "Content-Security-Policy" once console is clean.
			{
				key: "Content-Security-Policy",
				value: [
					"default-src 'self'",
					"base-uri 'self'",
					"object-src 'none'",
					`frame-ancestors 'self' ${process.env.NEXT_PUBLIC_DRUPAL_BASE_URL} https://mdmpreprod.onecloud.ma`,
					"form-action 'self'",
					"img-src 'self' data: blob: https:",
					"font-src 'self' data: https:",
					"style-src 'self' 'unsafe-inline' https:",
					[
						"script-src 'self' 'unsafe-inline' 'unsafe-eval'",
						"https://www.googletagmanager.com",
						"https://www.google.com",
						"https://www.gstatic.com",
						"https://maps.googleapis.com",
						"https://maps.gstatic.com",
						"https://cdn.cookielaw.org",
						"https://static.cloudflareinsights.com",
						"https://connect.facebook.net",
					].join(" "),
					[
						"connect-src 'self'",
						process.env.NEXT_PUBLIC_DRUPAL_BASE_URL,
						"https://www.google-analytics.com",
						"https://analytics.google.com",
						"https://region1.google-analytics.com",
						"https://www.googletagmanager.com",
						"https://www.google.com",
						"https://ad.doubleclick.net",
						"https://stats.g.doubleclick.net",
						"https://maps.googleapis.com",
						"https://maps.gstatic.com",
						"https://*.googleapis.com",
						"https://cdn.cookielaw.org",
						"https://geolocation.onetrust.com",
						"https://privacyportal.onetrust.com",
						"https://*.onetrust.com",
						"https://*.my.onetrust.com",
						"https://attijariwafa-privacy.my.onetrust.com",
						"https://static.cloudflareinsights.com",
						"https://cloudflareinsights.com",
						"https://connect.facebook.net",
						"https://www.facebook.com",
						"https://*.facebook.com",
						"https://*.a.run.app",
					].join(" "),
					"frame-src 'self' https://www.googletagmanager.com https://www.google.com https://www.recaptcha.net https://www.facebook.com https://connect.facebook.net",
					"media-src 'self' https: blob:",
					"worker-src 'self' blob:",
				].join("; "),
			},
		],
	},
}
